class CustomActionConstant {
}
CustomActionConstant.CUSTOM_ACTION_ALLOWED = [
    'aimee',
    'aimee-demo',
    'testorg1',
    'testorg2'
];
CustomActionConstant.CUSTOM_ACTION_DENY = [
    'meta'
];
export { CustomActionConstant };
//# sourceMappingURL=customActionConstants.js.map